import styled from 'styled-components'

export const SocialSharingLabel = styled.span`
  font-size: 16px;
`

export const SocialSharingList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: row;
`

export const SocialSharingListItem = styled.li`
  width: 30px;
  height: 30px;
  overflow: hidden;
  margin-left: 10px;
`

export const SocialSharingContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 30px;
  line-height: 30px;
`
